var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "secondary-nav ml-auto" }, [
    _c("ul", { staticClass: "navbar-nav" }, [
      _vm.searchActive
        ? _c(
            "li",
            { staticClass: "nav-item search", attrs: { title: "Search" } },
            [
              _c("div", { staticClass: "nav-link" }, [
                _c(
                  "button",
                  {
                    staticClass: "search",
                    attrs: { title: "Site Search" },
                    on: { click: _vm.triggerShowHeaderSearch },
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("span", { staticClass: "nav-label" }, [
                      _vm._v("Search"),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ecommerceEnabled
        ? _c(
            "li",
            { staticClass: "nav-item cart-element" },
            [_c("ecommerce-cart-block")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loggedIn
        ? _c(
            "li",
            { staticClass: "nav-item login-element" },
            [_c("user-login-popup")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loggedIn
        ? _c(
            "li",
            { staticClass: "nav-item" },
            [
              _c("page-element-user-my-account"),
              _vm._v(" "),
              _vm.helpActive
                ? [
                    _c("div", { staticClass: "context-help-container" }, [
                      _c(
                        "a",
                        {
                          staticClass: "helper",
                          attrs: { href: "javascript:" },
                        },
                        [
                          _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.hover",
                                  value: "This brings you to your User Portal!",
                                  expression:
                                    "'This brings you to your User Portal!'",
                                  modifiers: { hover: true },
                                },
                              ],
                              attrs: { title: "Context Help" },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: _vm.question },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("assets/menu-icons/search.svg") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }